import { Col } from 'components';

import { ChatItem } from './';

const Chat = ({ messages }) => {
  if (!messages?.length) return null;

  return (
    <Col
      wid="100%"
      noFlex
      start
      ht="465px"
      maxWid="468px"
      pad="0 0 24px"
      scrollY
      reverse
      style={{
        overflowX: 'hidden',
        background: 'linear-gradient(90deg, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0) 90%)'
      }}
    >
      {messages.map((x) => (
        <ChatItem {...x} />
      ))}
    </Col>
  );
};

export default Chat;
